import React from "react";

type Props = {
  className?: string;
};

function SearchOutlineIcon({className}: Props) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Grouped: the rich-text toolbar restyles an svg's direct path children. */}
      <g>
        <circle cx="6.5" cy="6.5" r="4.75" fill="none" stroke="currentColor" />
        <path d="M10 10L14.5 14.5" fill="none" stroke="currentColor" />
      </g>
    </svg>
  );
}

export default SearchOutlineIcon;
